/**
 * OSPatchReadOnlyNotice — shown at the top of every OS Patch Management page
 * when the tenant's service tier is "Apps Management + read-only OS Patch".
 *
 * The create and change controls on those pages are hidden for such a
 * tenant, so this notice is what tells an administrator why. The backend
 * refuses the same actions independently (409 capability_unavailable).
 */
import { Eye } from "lucide-react";
import { usePermissions } from "@/contexts/PermissionsContext";

export default function OSPatchReadOnlyNotice({ className = "" }) {
  const { canUseOSPatch, canWriteOSPatch } = usePermissions();
  if (!canUseOSPatch || canWriteOSPatch) return null;

  return (
    <div
      className={`flex items-start gap-3 rounded-lg border border-white/15 bg-white/5 p-3 text-sm ${className}`}
      data-testid="os-patch-read-only-notice"
      role="status"
    >
      <Eye className="h-5 w-5 shrink-0 text-white/80 mt-0.5" />
      <div className="space-y-0.5">
        <p className="font-medium text-white">Read-only OS Patch Management</p>
        <p className="text-white/70">
          Your organisation&apos;s ALICE plan includes OS Patch Management for
          reporting: Windows security update levels, patch compliance, device
          health, Windows 11 readiness and firmware.
        </p>
      </div>
    </div>
  );
}
